import {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {useWorkspace} from '../hooks/useWorkspace';
import {dataClient} from '../data/dataClient';

const {FiSliders, FiClock, FiCheck} = FiIcons;

export default function Settings() {
  const {business, brandProfile, activity = []} = useWorkspace();
  const [saveNotice, setSaveNotice] = useState(null);

  async function updateBusiness(field, value) {
    await dataClient.setBusiness({[field]: value}, {});
    await dataClient.create('auditLogs', {
      text: `Updated business ${field} to “${String(value).slice(0, 30)}${String(value).length > 30 ? '…' : ''}”`,
      time: 'Just now'
    });
    showFeedback(`Saved ${field}`);
  }

  async function updateBrand(field, value) {
    await dataClient.setBusiness({}, {[field]: value});
    await dataClient.create('auditLogs', {
      text: `Updated brand ${field} to “${String(value).slice(0, 30)}${String(value).length > 30 ? '…' : ''}”`,
      time: 'Just now'
    });
    showFeedback(`Saved ${field}`);
  }

  function showFeedback(msg) {
    setSaveNotice(msg);
    setTimeout(() => setSaveNotice(null), 2500);
  }

  const settingsChanges = activity.filter(
    (a) => a.text?.toLowerCase().includes('update') || a.text?.toLowerCase().includes('set') || a.text?.toLowerCase().includes('change')
  );

  return (
    <div className="page narrow">
      <header className="page-header inline spread">
        <div>
          <span className="eyebrow">Settings</span>
          <h1>Workspace preferences.</h1>
          <p>Manage workspace details, shared brand context, and review the audit changelog.</p>
        </div>
        {saveNotice && (
          <div className="inline" style={{color: '#16a34a', fontSize: 'var(--type-sm)', fontWeight: 600}}>
            <SafeIcon icon={FiCheck} />
            <span>{saveNotice}</span>
          </div>
        )}
      </header>

      {/* Business Details Panel */}
      <section className="panel">
        <div className="section-heading">
          <div>
            <span className="eyebrow">Workspace</span>
            <h2>Business details</h2>
          </div>
        </div>

        <div className="form-grid">
          <label>
            Business name
            <input
              value={business.name || ''}
              onChange={(event) => updateBusiness('name', event.target.value)}
            />
          </label>
          <label>
            Industry
            <input
              value={business.industry || ''}
              onChange={(event) => updateBusiness('industry', event.target.value)}
            />
          </label>
          <label className="full">
            Audience
            <textarea
              value={business.audience || ''}
              onChange={(event) => updateBusiness('audience', event.target.value)}
            />
          </label>
          <label className="full">
            Goals
            <textarea
              value={business.goals || ''}
              onChange={(event) => updateBusiness('goals', event.target.value)}
            />
          </label>
        </div>
      </section>

      {/* Shared Voice Panel */}
      <section className="panel top-gap">
        <div className="section-heading">
          <div>
            <span className="eyebrow">Brand profile</span>
            <h2>Shared voice</h2>
          </div>
        </div>

        <div className="form-grid">
          <label>
            Voice
            <textarea
              value={brandProfile.voice || ''}
              onChange={(event) => updateBrand('voice', event.target.value)}
            />
          </label>
          <label>
            Language to avoid
            <textarea
              value={brandProfile.avoid || ''}
              onChange={(event) => updateBrand('avoid', event.target.value)}
            />
          </label>
        </div>
      </section>

      {/* Simple Changelog from Audit Entries */}
      <section className="panel top-gap">
        <div className="section-heading">
          <div>
            <span className="eyebrow">Audit log</span>
            <h2>Settings changelog</h2>
          </div>
          <SafeIcon icon={FiClock} className="muted" />
        </div>

        <div className="hq-activity-list">
          {settingsChanges.length === 0 ? (
            <p className="muted" style={{fontSize: 'var(--type-sm)', padding: '8px 0'}}>
              No settings changes recorded yet. Adjusting business details or brand voice creates audit entries here.
            </p>
          ) : (
            settingsChanges.slice(0, 8).map((change) => (
              <div key={change.id} className="hq-activity-row">
                <span className="activity-icon-badge">
                  <SafeIcon icon={FiSliders} />
                </span>
                <div className="activity-text">
                  <p>{change.text}</p>
                  <small>{change.time || 'Recently'}</small>
                </div>
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}
